/**
 * ComplianceFooter.tsx — MER Algo Footprints v9.2.0
 *
 * Phase 2: Global Trading Header companion.
 *
 * Restores the v8.1.1 compliance footer that was lost when the v9.1.1
 * react-router shell took over from the legacy state-based App.tsx.
 *
 * The original markup (App.tsx:292–302) is preserved verbatim, only
 * extracted into a standalone component and pinned to the bottom of the
 * AppShell viewport. Same colors, same spacing, same copy.
 *
 * Pure presentational — no hooks, no data dependencies.
 */

import React from 'react';

export interface ComplianceFooterProps {
  /** Pin to viewport bottom (default true). When false, renders in-flow. */
  fixed?: boolean;
  /** Left offset to clear the nav rail (default 52px). */
  leftOffset?: number;
}

export function ComplianceFooter({
  fixed = true,
  leftOffset = 52,
}: ComplianceFooterProps) {
  const positionStyle: React.CSSProperties = fixed
    ? {
        position: 'fixed',
        bottom: 0,
        left: leftOffset,
        right: 0,
        zIndex: 800,
      }
    : { flexShrink: 0 };

  return (
    <footer
      role="contentinfo"
      aria-label="Compliance disclosure"
      style={{
        ...positionStyle,
        background: 'var(--navy)',
        borderTop: '1px solid var(--gold-dim)',
        padding: '7px 24px',
        textAlign: 'center',
        fontFamily: 'var(--mono)',
        fontSize: 10,
        color: 'var(--blue-dim)',
        letterSpacing: '.5px',
        lineHeight: 1.6,
      }}
    >
      FOR INFORMATIONAL AND ANALYTICAL PURPOSES ONLY. THIS IS NOT PERSONALIZED INVESTMENT ADVICE.
      CONSULT A LICENSED FINANCIAL ADVISOR BEFORE MAKING INVESTMENT DECISIONS.
      {' · '}
      <span style={{ color: 'var(--gold)', fontWeight: 700 }}>
        MALDONADO EQUITY RESEARCH © 2026
      </span>
    </footer>
  );
}
